import 'Pages/About/About.css';
import 'Helper/CommonlyUsed.css';
import {
    Col,
    Container,
    Image,
    Row
} from 'react-bootstrap';
import ProfessionalPhoto from 'Images/Professional-Photo.jpg';

export default function About(): JSX.Element {
    return (
        <Container>
            <Row className="pt-2 px-5">
                <h1>About Me</h1>
            </Row>
            <Row className="px-5">
                <Col sm={8} className="col-text">
                    <p>Hello, my name is William Xiong.</p>
                    <ul>
                        <li>
                            I am a Software Engineer at <a href="https://www.accurate.com/" style={{color: 'darkblue'}}>
                            Accurate Background Screening</a>.
                        </li>
                        <li>
                            2021 Bachelors of Science graduate at <a href="https://www.metrostate.edu/">Metropolitan
                            State University</a>.
                        </li>
                        <li>
                            Before college I served 4 years in the United States Marine Corps as a Transmissions System
                            Operator (radio operator for short).
                        </li>
                        <li>
                            My favorite football team is the Minnesota Vikings, I like to hang out with my family, and I
                            like to do house projects/chores during my spare time.
                        </li>
                    </ul>
                </Col>
                <Col sm={2}>
                    <Image src={ProfessionalPhoto}/>
                    <Image
                        className="military-photo"
                        src="https://media.defense.gov/2015/May/13/2001140762/1088/820/0/031748-A-GRW84-537.jpg"
                        title="U.S. Marine Corps Lance Cpl. William Xiong awaits the arrival of earthquake victims at a medical triage area at Tribhuvan International Airport, Kathmandu, Nepal, May 13, 2015. | defense.gov"
                    />
                </Col>
            </Row>
            <br/>
            <Row className="pt-2 px-5">
                <h1>About this site</h1>
            </Row>
            <Row className="px-5">
                <Col sm={12} className="col-text">
                    <p>
                        This site is created with <b>React</b>, <b>Typescript</b>, <b>Github Pages</b>,
                        and <b>Google Domain</b>. I used CSS and
                        {" "}<a href="https://react-bootstrap.github.io/">React-Bootstrap</a> for the styling.
                    </p>
                </Col>
            </Row>
        </Container>
    );
};
